// 更多 UEditor 配置，参考 http://fex.baidu.com/ueditor/#start-c

export const myConfig = {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 500,
    // 初始容器宽度
    initialFrameWidth: "100%",
    zIndex: 99999,
    maximumWords: 6000, // 允许的最大字符数
    enableAutoSave: false, // 启用自动保存
    // 服务器地址
    serverUrl: "/credit-platformapi/credit/ueditor/0000", // 服务端图片接口地址
    // UEDITOR_HOME_URL: process.env.VUE_APP_PUBLIC_PATH + "/UEditor/", // 访问 UEditor 静态资源的根路径，
    UEDITOR_HOME_URL: "UEditor/", // 访问 UEditor 静态资源的根路径，
    
    toolbars: [
      [
        "undo",
        "redo",
        "|",
        "bold",
        "italic",
        "underline",
        "fontborder",
        "strikethrough",
        "superscript",
        "subscript",
        "removeformat",
        "formatmatch",
        //'autotypeset',
        "blockquote",
        "pasteplain",
        "|",
        "forecolor",
        "backcolor",
        "insertorderedlist",
        "insertunorderedlist",
        "selectall",
        "cleardoc",
        "|",
        "rowspacingtop",
        "rowspacingbottom",
        "lineheight",
        "|",
        "customstyle",
        "paragraph",
        "fontfamily",
        "fontsize",
        "|",
        "directionalityltr",
        "directionalityrtl",
        "indent",
        "|",
        "justifyleft",
        "justifycenter",
        "justifyright",
        "justifyjustify",
        "|",
        "touppercase",
        "tolowercase",
        "|",
        "link",
        "unlink",
        "anchor",
        "|",
        "imagenone",
        "imageleft",
        "imageright",
        "imagecenter",
        "|",
        // 'emotion',
        "pagebreak",
        "template",
        "|",
        "horizontal",
        "date",
        "time",
        "spechars",
        "simpleupload",
        "|",
        "inserttable",
        "deletetable",
        "insertparagraphbeforetable",
        "insertrow",
        "deleterow",
        "insertcol",
        "deletecol",
        "mergecells",
        "mergeright",
        "mergedown",
        "splittocells",
        "splittorows",
        "splittocols",
        "|",
        "print",
        "preview",
        "searchreplace",
        // 'fullscreen', 'source', 'undo', 'redo', 'bold'
      ],
    ],
  };
  